<template>
  <v-dialog v-model="modal_lumpsum_investment_open_status" persistent>
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              <label class="form-checkbox">
                <input
                  type="checkbox"
                  v-model="selectAll"
                  @click="allCheckbox"
                />
                <i class="form-icon"></i>
              </label>
            </th>
            <th class="text-left">Mutual Fund Company</th>
            <th class="text-left">Owner</th>
            <th class="text-left">Scheme Type</th>
            <th class="text-left">Scheme Name</th>
            <th class="text-left">Folio Number</th>
            <th class="text-left">Total Investment</th>
            <th class="text-left">Balance Units</th>
            <th class="text-left">Nominee 1</th>
            <th class="text-left">Nominee 2</th>
            <th class="text-left">Nominee 3</th>
            <th class="text-left">Validate</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in get_uploaded_lumpsum_investment_list"
            :key="index"
            :id="row_id_txt + index"
            :style="
              item.is_mutual_fund_company_valid &&
              item.is_account_owner_valid &&
              item.is_scheme_type_valid &&
              item.is_scheme_name_valid
                ? { 'background-color': '#98FB98' }
                : {}
            "
          >
            <td>
              <label class="form-checkbox">
                <input
                  type="checkbox"
                  :value="index"
                  class="csv-check"
                  v-model="selected"
                  @change="singleCheckbox($event, index)"
                />
                <i class="form-icon"></i>
              </label>
            </td>
            <td v-if="item.is_mutual_fund_company_valid == true">
              {{ item.mutual_fund_company }}
            </td>
            <td class="invalid" v-else>{{ item.mutual_fund_company }}</td>
            <td v-if="item.is_account_owner_valid == true">{{ item.owner }}</td>
            <td class="invalid" v-else>{{ item.owner }}</td>
            <td v-if="item.is_scheme_type_valid == true">
              {{ item.scheme_type }}
            </td>
            <td class="invalid" v-else>{{ item.scheme_type }}</td>
            <td v-if="item.is_scheme_name_valid == true">
              {{ item.scheme_name }}
            </td>
            <td class="invalid" v-else>{{ item.scheme_name }}</td>
            <td>{{ item.folio_number }}</td>
            <td>{{ item.total_investment }}</td>
            <td>{{ item.balance_units }}</td>
            <td>{{ item.nominee_1 }}</td>
            <td>{{ item.nominee_2 }}</td>
            <td>{{ item.nominee_3 }}</td>
            <td>
              <v-icon
                small
                class="mr-2"
                @click="editItem(item, index)"
                title="Validate Data"
              >
                mdi-pencil</v-icon
              >
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="12" style="text-align: right">
              <p>
                <span style="color: red"
                  >Note: 1- For data showing in Red please click validate to
                  verify and confirm</span
                >
              </p>
              <p>
                <span style="color: red"
                  >2- All dates should be in "yyyy-mm-dd" format</span
                >
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="12">
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="blue-border-btn" text @click="firstDialog">
                  Close
                </v-btn>
                <v-btn
                  style="
                    background-color: #051d42 !important;
                    color: #fff !important;
                    height: 46px !important;
                    font-family: Work Sans, sans-serif;
                    min-width: 200px !important;
                  "
                  text
                  @click="finalSubmit"
                >
                  Confirm
                </v-btn>
              </v-card-actions>
            </td>
          </tr>
        </tfoot>
      </template>
    </v-simple-table>
  </v-dialog>
</template>
<script>
import axios from "axios";
import { Auth } from "aws-amplify";
export default {
  props: [
    "modal_lumpsum_investment_open_status",
    "get_uploaded_lumpsum_investment_list",
  ],
  data: () => ({
    mf_master_data: [],
    account_type: "",
    alltick: true,
    ex4: null,
    selectedArr: [],
    rolesSelected: "",
    selected: [],
    selectAll: false,
    totalCount: null,
    row_id_txt: "row_",
    account_login_user_name: "",
  }),
  created() {},
  mounted() {},
  methods: {
    allCheckbox() {
      this.selected = [];
      if (!this.selectAll) {
        for (var i in this.get_uploaded_lumpsum_investment_list) {
          this.selected.push(parseInt(i));
        }
      }
    },
    singleCheckbox(index) {
      this.totalCount = this.get_uploaded_lumpsum_investment_list.length;
      if (this.selected.length == this.totalCount) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    firstDialog() {
      this.modal_lumpsum_investment_open_status = false;
    },

    finalSubmit(e) {
      if (this.selected.length > 0) {
        this.checkFormData = [];
        var error = 0;

        for (
          let i = 0;
          i < this.get_uploaded_lumpsum_investment_list.length;
          i++
        ) {
          if (this.selected.indexOf(i) !== -1) {
            let row = this.get_uploaded_lumpsum_investment_list[i];
            console.log(
              this.get_uploaded_lumpsum_investment_list[i].folio_number
            );
            if (
              row.is_mutual_fund_company_valid &&
              row.is_account_owner_valid &&
              row.is_scheme_type_valid
            ) {
              this.checkFormData.push({
                mutual_fund_company:
                  this.get_uploaded_lumpsum_investment_list[i]
                    .mutual_fund_company,
                owner: this.get_uploaded_lumpsum_investment_list[i].owner,
                scheme_type:
                  this.get_uploaded_lumpsum_investment_list[i].scheme_type,
                scheme_name:
                  this.get_uploaded_lumpsum_investment_list[i].scheme_name,
                folio_number:
                  this.get_uploaded_lumpsum_investment_list[i].folio_number,
                total_investment:
                  this.get_uploaded_lumpsum_investment_list[i].total_investment,
                balance_units:
                  this.get_uploaded_lumpsum_investment_list[i].balance_units,
                nominee_1:
                  this.get_uploaded_lumpsum_investment_list[i].nominee_1,
                nominee_2:
                  this.get_uploaded_lumpsum_investment_list[i].nominee_2,
                nominee_3:
                  this.get_uploaded_lumpsum_investment_list[i].nominee_3,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: "Kindly validate row:" + (i + 1),
                confirmButtonText: `Ok`,
              });
              error = 1;
              break;
            }
          }
        }
        if (!error) {
          let cognito_idp = atob(localStorage.getItem("cognito_idp"));
          Auth.currentAuthenticatedUser({
            bypassCache: false,
          }).then((user) => {
            this.account_login_user_name = user.attributes["custom:name"];
          });
          let formdata = new FormData();
          formdata.append("aws_cognito_id", cognito_idp);
          formdata.append("csv_data", JSON.stringify(this.checkFormData));
          formdata.append("name", this.account_login_user_name);
          axios
            .post(
              process.env.VUE_APP_ROOT_API + "save-lumpsum-investment-csv",
              formdata
            )
            .then((response) => {
              this.csv_dialog = false;
              this.is_modal_open = false;
              this.$loading(false);
              Toast.fire({
                icon: "success",
                title: "Data saved successfully",
              });
              this.$router.push({ name: "mutual-dashboard" }).catch(() => {});
            })
            .catch(() => {
              this.$loading(false);
            });
        }
      } else {
        Toast.fire({
          icon: "error",
          title: "Please select at least one.",
        });
        return;
      }
    },

    editItem(edit_row_data_item, index) {
      this.$emit("getLumpsumInvestmentEditFormData", {
        row_item_detail: edit_row_data_item,
        is_edit_modal_open: true,
        row_index: index,
        type: "savings_account",
      });
    },
  },
};
</script>
<style scoped>
.invalid {
  color: red;
}

.title_note {
  text-align: center;
  font-weight: bold;
  color: "#263a4az";
  font-size: 20px;
}

.row.bottom-noteboxs {
  margin: 0px;
  background-color: #fff;
}

.row.bottom-notebox .col-lg-12 {
  text-align: center;
}
</style>